<template>
    <div id="app">
        <loading v-show="isLoading"></loading>
        <keep-alive>
            <router-view/>
        </keep-alive>
    </div>
</template>
<script>
    import loading from '@/components/loading';
    import lib from '@/components/js/lib';

    export default {
        name: 'app',
        computed: {
            isLoading() {
                return this.$store.state.isLoading
            }
        },
        components: { loading },
        created: function() {
            // lib.setFontSize(750,100);
        }
    }

</script>
<style lang='scss'>

    @import "./style/enterPC";
    @import "./style/fonts/pcFont.scss";

</style>



// WEBPACK FOOTER //
// src/enterPC.vue